import React from 'react';
import './Studio.css';

export default function () {
    return (
        <>
            <section className='Sec-2-studio pt-5'>   {/* section 2 studio starts */}

                <div className="container">

                    <div className="row">

                        <div className='col-12 col-md-6'>

                            <h3 className='text-center fw-bold heading-one'>Welcome to CRYSTAL Design</h3>

                            <h1 className='text-center fw-bold heading-two'>Digital Studio in Bangkok</h1>

                            <p className='pt-md-5 pt-2 '>Crystal is free web template for everyone. Feel free to use it for your website. Please spread a word about <span className='temp fw-bold'>template</span><span className='mo fw-bold'>mo</span> to your friends. Integer lorem magna, gravida vitae metus a, euismod faucibus nisi. In sed nulla magna. Nulla in mauris ullamcorper, cursus lorem lobortis, pellentesque enim. Ut vel pellentesque est. Maecenas sed malesuada tellus</p>

                        </div>

                        <div className='col-12 col-md-6'>

                            <h1 className='fw-bold text-center'>Our Location</h1>

                            <div className="row pt-3">

                                <div className='col-12 col-md-6'>

                                    <img src="/images/company-img-1.jpg" alt="" className='img-fluid pt-2'/>
                                    <img src="/images/company-img-2.jpg" alt="" className='img-fluid pt-2'/>

                                </div>

                                <div className='col-12 col-md-6'>

                                    <img src="/images/company-img-3.jpg" alt="" className='img-fluid pt-2'/>
                                    <img src="/images/company-img-4.jpg" alt="" className='img-fluid pt-2'/>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </section> {/* section 2 studio Ends */}
        </>
    )
}